<section class="timeline" id="linha-do-tempo-da-gravacao" aria-label="Linha do tempo da gravação">
  <h3 class="timeline__title">Linha do tempo da gravação</h3>

  @if (carregando()) {
    <app-loading />
  } @else if (erro()) {
    <p class="timeline__muted">Não foi possível carregar a linha do tempo agora.</p>
  } @else if (linhaDoTempo(); as t) {
    @if (!t.hasEvents) {
      <p class="timeline__muted">
        Não há eventos guardados desta reunião. As reuniões gravadas antes dos eventos da Recall
        serem guardados não têm linha do tempo.
      </p>
    } @else {
      @if (t.otherRecorders.length) {
        <p class="timeline__recorders" role="note">
          <i class="pi pi-microphone" aria-hidden="true"></i>
          Outro gravador na call: {{ t.otherRecorders.join(', ') }}
        </p>
      }

      <ol class="timeline__list">
        @for (item of itens(); track $index) {
          <li class="timeline__item" [class]="'timeline__item timeline__item--' + item.tone">
            <span class="timeline__time">{{ hora(item) }}</span>
            <i
              class="pi timeline__icon"
              [class]="'pi timeline__icon ' + icone(item)"
              aria-hidden="true"></i>
            <span class="timeline__text">{{ item.text }}</span>
          </li>
        }
      </ol>

      @if (escondidos()) {
        <button type="button" class="timeline__toggle" (click)="verTudo.set(!verTudo())">
          <i
            class="pi"
            [class.pi-chevron-down]="!verTudo()"
            [class.pi-chevron-up]="verTudo()"
            aria-hidden="true"></i>
          {{
            verTudo()
              ? 'Mostrar só o que importa'
              : 'Ver todas as entradas e saídas (' + escondidos() + ')'
          }}
        </button>
      }

      <p class="timeline__hint">
        A Recall informa o que aconteceu com o bot, mas não quem o removeu da call.
      </p>
    }
  }
</section>
